import { Popover } from "flowbite-react";
import { Bell } from "lucide-react";
import { NotificationDropdown } from "@/features/notifications/components/NotificationDropdown";
import { useNotificationsContext } from "@/features/notifications/context/NotificationsContext";
import RoundedIconButton from "@/shared/components/customButtons/roundedIconButton";

export const NotificationBell = () => {
  const { totalCount } = useNotificationsContext();
  const hasNotifications = totalCount > 0;

  return (
    <Popover
      aria-labelledby="notification-popover"
      content={<NotificationDropdown />}
      trigger="click"
      placement="bottom-end"
    >
      <div className="relative">
        <RoundedIconButton
          icon={Bell}
          ariaLabel="Notifications"
          className="[&_svg]:!transition-colors [&_svg]:!duration-[600ms] [&_svg]:!ease-in-out"
        />
        {hasNotifications && (
          <span className="absolute top-0 right-0 flex items-center justify-center min-w-5 h-5 px-1 text-xs font-bold text-white bg-error rounded-full pointer-events-none">
            {totalCount > 99 ? "99+" : totalCount}
          </span>
        )}
      </div>
    </Popover>
  );
};
